module.exports = __webpack_public_path__ + "media/images/payments/google_subscription_start-9f6f11d6b7f5c1971cf53cb0512ab23e.png";